import React, { useState, useEffect } from "react";
import { checkResult, createFilePath } from "@/common";
import { useWatchState } from "@/store";
import { BaseService } from "@/service";
import BraftEditor from "braft-editor";
import { Industrial, Business, Height, Attribute, Achievement, Shape, Scale, Expect, Difficulty, Degree, Strength, Trl1_9, Leader_education, Leader_title, Team_person, Team_intermediate, Team_experience, ProjectScopeName } from "../projectRec/projectFunction"
import { Modal, Descriptions, Divider, Button, Icon, Collapse } from "antd";
import moment from "moment";

const { Panel } = Collapse;

function callback(key) {
    console.log(key);
}

const NAME = "projectContacts";

const App = () => {
    const [[IS_REGION], [{ IS_LOGIN, info }]] = useWatchState(["IS_REGION", "user",]);
    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
    const [[modalProps, setProps]] = useWatchState(["modal." + NAME]);
    const { title = "", show, hide, width = 1000, DetailId } = modalProps;
    const [items, setItems] = useState([]);
    const [data, setData] = useState([]);
    const [orgName, setOrgName] = useState('');
    const [personName, setPersonName] = useState('');
    const [submit_name, setSubmit_name] = useState('');
    const [submit_account, setSubmit_account] = useState('');
    const [files, setFiles] = useState([]);

    useEffect(() => {
        if (DetailId) {
            getProjectUserRecord(DetailId);
        }
    }, [DetailId])

    const getProjectUserRecord = projectUser_id => {
        BaseService.list({
            table: "thtt_project_contacts",
            where: {
                id: projectUser_id,
                is_delete: 0,
            },
        }).then(res => {
            if (!checkResult(res)) return;
            const data = res.data.result[0];
            if (data.project_item_id) {
                BaseService.list({
                    table: "thtt_project",
                    
                    where: {
                        id: data.project_item_id,
                        is_delete: 0,
                    },
                }).then(res => {
                    if (!checkResult(res)) return;
                    const items = res.data.result[0];

                    /*关联用户表，显示用户名称和联系方式*/
                    if (items.declarant_user_id) {
                        BaseService.list({
                            table: "thtt_user",
                            columns: "name AS submit_name,account AS submit_account",
                            where: {
                                user_id: items.declarant_user_id,
                                is_delete: 0,
                            },
                        }).then((resUser) => {
                            if (!checkResult(resUser)) return;
                            setSubmit_account(resUser.data.result[0].submit_account);
                            setSubmit_name(resUser.data.result[0].submit_name);
                        });
                    }

                    /*推荐单位和推荐个人的名称显示开始*/
                    const orgRecId = items.orgRec_id;
                    const personRecId = items.personRec_id;
                    if ((orgRecId !== 'null') && (personRecId == 'null' || personRecId == '已选择推荐单位')) {
                        BaseService.list({
                            table: "thtt_project_recommend",
                            where: {
                                id: orgRecId,
                                is_delete: 0,
                            },
                        }).then(resRecOrg => {
                            if (!checkResult(resRecOrg)) return;
                            setOrgName(resRecOrg.data.result[0].org_name);
                        })
                    }
                    else {
                        BaseService.list({
                            table: "thtt_project_recommend",
                            where: {
                                id: personRecId,
                                is_delete: 0,
                            },
                        }).then(resRecPerson => {
                            if (!checkResult(resRecPerson)) return;
                            setPersonName(resRecPerson.data.result[0].org_name);
                        })
                    }
                    /*推荐单位和推荐个人的名称显示开始*/
                    setItems(items);
                })
            }
            if (data.project_item_id) {
                BaseService.list({
                    table: "thtt_attachment_relation",
                    columns: "id,file_name,file_path",
                    where: {
                        item_id: data.project_item_id,
                        is_delete: 0,
                    },
                }).then((res) => {
                    if (!checkResult(res)) return;
                    const files = res.data.result;
                    setFiles(files);
                });
            } else setFiles({});


            setData(data);
        })
    }



    return (
        <Modal
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose
            onCancel={hide}
            footer={false}
        >
            <Collapse defaultActiveKey={[(data.project_contacts_type === 2) ? '2' : ((data.project_contacts_type === 1) ? '1' : '0')]} onChange={callback}>
                {(data.project_contacts_type === 1) &&
                    <Panel header="非成果方合作服务申请详情" key="1">
                        <Divider>申请人信息</Divider>
                        <Descriptions layout="vertical" bordered column={5}>
                            <Descriptions.Item label="单位" span={5}>{data.contacts_org}</Descriptions.Item>
                            <Descriptions.Item label="职务" span={1}>{data.contacts_position}</Descriptions.Item>
                            <Descriptions.Item label="姓名" span={1}>{data.contacts_name}</Descriptions.Item>
                            <Descriptions.Item label="电话" span={1}>{data.contacts_phone}</Descriptions.Item>
                            <Descriptions.Item label="提交时间" span={1}> {moment(parseInt(data.add_date) * 1000).format("YYYY-MM-DD")}</Descriptions.Item>
                        </Descriptions>
                        <Divider>发布会科技成果</Divider>
                        <Descriptions layout="vertical" bordered column={6}>
                            <Descriptions.Item label="发布会科技成果名称" span={6}>{items.optimize_name}</Descriptions.Item>
                            <Descriptions.Item label="发布会科技成果简介" span={6}>{items.optimize_profile}</Descriptions.Item>
                            <Descriptions.Item label="发布会科技成果领域" span={1}>{ProjectScopeName(items.scope)}</Descriptions.Item>
                            <Descriptions.Item label="申报单位" span={2}>{items.org_name}</Descriptions.Item>
                            <Descriptions.Item label="项目地区" span={1}>{items.org_province_name}</Descriptions.Item>
                            <Descriptions.Item label={(items.orgRec_id !== 'null') ? '项目推荐单位：' : '项目推荐个人：'} span={2}>{(items.orgRec_id !== 'null') ? orgName : personName}</Descriptions.Item>
                        </Descriptions>
                        <Divider>资本合作</Divider>
                        <Descriptions layout="vertical" bordered column={5} style={{ textAlign: 'center' }}>
                            <Descriptions.Item label="项目股权投资">{(data.equity_investment === 1) ? '是' : ((data.equity_investment === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="项目金融信贷">{(data.financial_credit === 1) ? '是' : ((data.financial_credit === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="项目并购合作">{(data.merger_acquisition === 1) ? '是' : ((data.merger_acquisition === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="项目融资代理">{(data.financing_agency === 1) ? '是' : ((data.financing_agency === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="项目上市运作">{(data.listing_operation === 1) ? '是' : ((data.listing_operation === 2) ? '否' : '未选择')}</Descriptions.Item>
                        </Descriptions>
                        <Divider>技术合作</Divider>
                        <Descriptions layout="vertical" bordered column={4} style={{ textAlign: 'center' }}>
                            <Descriptions.Item label="技术专家顾问咨询">{(data.consulting === 1) ? '是' : ((data.consulting === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="技术中心合作共建">{(data.joint_construction === 1) ? '是' : ((data.joint_construction === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="技术项目合作研发">{(data.research_development === 1) ? '是' : ((data.research_development === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="技术成果转移交易">{(data.transfer_transaction === 1) ? '是' : ((data.transfer_transaction === 2) ? '否' : '未选择')}</Descriptions.Item>
                        </Descriptions>
                        <Divider>产业合作</Divider>
                        <Descriptions layout="vertical" bordered column={4} style={{ textAlign: 'center' }}>
                            <Descriptions.Item label="产业资源供给">{(data.resource_supply === 1) ? '是' : ((data.resource_supply === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="产业链条配套">{(data.chain_matching === 1) ? '是' : ((data.chain_matching === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="产业园区招商">{(data.attract_investment === 1) ? '是' : ((data.attract_investment === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="产业政策扶持">{(data.policy_support === 1) ? '是' : ((data.policy_support === 2) ? '否' : '未选择')}</Descriptions.Item>
                        </Descriptions>
                        <Divider>市场合作</Divider>
                        <Descriptions layout="vertical" bordered column={4} style={{ textAlign: 'center' }}>
                            <Descriptions.Item label="市场战略规划设计">{(data.plan_design === 1) ? '是' : ((data.plan_design === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="产品市场包装宣传">{(data.packaging_promotion === 1) ? '是' : ((data.packaging_promotion === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="应用场景拓展开发">{(data.expand_development === 1) ? '是' : ((data.expand_development === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="产品销售渠道代理">{(data.channel_agent === 1) ? '是' : ((data.channel_agent === 2) ? '否' : '未选择')}</Descriptions.Item>
                        </Descriptions>
                    </Panel>}
                {(data.project_contacts_type === 2) &&
                    <Panel header="成果方成果延伸服务申请详情" key="2">
                        <Divider>申请人信息</Divider>
                        <Descriptions layout="vertical" bordered column={5}>
                            <Descriptions.Item label="单位" span={5}>{data.contacts_org}</Descriptions.Item>
                            <Descriptions.Item label="职务" span={1}>{data.contacts_position}</Descriptions.Item>
                            <Descriptions.Item label="姓名" span={1}>{data.contacts_name}</Descriptions.Item>
                            <Descriptions.Item label="电话" span={1}>{data.contacts_phone}</Descriptions.Item>
                            <Descriptions.Item label="提交时间" span={1}> {moment(parseInt(data.add_date) * 1000).format("YYYY-MM-DD")}</Descriptions.Item>
                        </Descriptions>
                        <Divider>发布会科技成果名称</Divider>
                        <Descriptions layout="vertical" bordered column={6}>
                            <Descriptions.Item label="发布会科技成果名称" span={6}>{items.optimize_name}</Descriptions.Item>
                            <Descriptions.Item label="发布会科技成果简介" span={6}>{items.optimize_profile}</Descriptions.Item>
                            <Descriptions.Item label="发布会科技成果领域" span={1}>{ProjectScopeName(items.scope)}</Descriptions.Item>
                            <Descriptions.Item label="申报单位" span={2}>{items.org_name}</Descriptions.Item>
                            <Descriptions.Item label="成果地区" span={1}>{items.org_province_name}</Descriptions.Item>
                            <Descriptions.Item label={(items.orgRec_id !== 'null') ? '项目推荐单位：' : '项目推荐个人：'} span={2}>{(items.orgRec_id !== 'null') ? orgName : personName}</Descriptions.Item>
                        </Descriptions>
                        <Divider>精准化供需对接推介活动</Divider>
                        <Descriptions layout="vertical" bordered style={{ textAlign: 'center' }}>
                            <Descriptions.Item label="定向推介活动">{(data.directional === 1) ? '是' : ((data.directional === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="专项推介活动">{(data.special === 1) ? '是' : ((data.special === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="专题推介活动">{(data.special_subject === 1) ? '是' : ((data.special_subject === 2) ? '否' : '未选择')}</Descriptions.Item>
                        </Descriptions>
                        <Divider>专业化诊断评价策划业务</Divider>
                        <Descriptions layout="vertical" bordered column={4} style={{ textAlign: 'center' }}>
                            <Descriptions.Item label="项目过滤筛选">{(data.filter === 1) ? '是' : ((data.filter === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="项目对接撮合">{(data.matchmaking === 1) ? '是' : ((data.matchmaking === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="项目策划促进">{(data.planning_promotion === 1) ? '是' : ((data.planning_promotion === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="项目落地平台">{(data.landing_platform === 1) ? '是' : ((data.landing_platform === 2) ? '否' : '未选择')}</Descriptions.Item>
                        </Descriptions>
                        <Divider>数字化云网智能服务平台</Divider>
                        <Descriptions layout="vertical" bordered style={{ textAlign: 'center' }}>
                            <Descriptions.Item label="数字化云网智能服务平台">{(data.digitized_cloud === 1) ? '是' : ((data.digitized_cloud === 2) ? '否' : '未选择')}</Descriptions.Item>
                        </Descriptions>
                        <Divider>常态化共建科创实体机构</Divider>
                        <Descriptions layout="vertical" bordered style={{ textAlign: 'center' }}>
                            <Descriptions.Item label="地区合作机构">{(data.regional === 1) ? '是' : ((data.regional === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="行业合作机构">{(data.industry === 1) ? '是' : ((data.industry === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="国际合作机构">{(data.international === 1) ? '是' : ((data.international === 2) ? '否' : '未选择')}</Descriptions.Item>
                        </Descriptions>
                        <Divider>生态化落地项目育成工场</Divider>
                        <Descriptions layout="vertical" bordered column={5} style={{ textAlign: 'center' }}>
                            <Descriptions.Item label="资本市场投资项目">{(data.capital_market === 1) ? '是' : ((data.capital_market === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="产业园区招商项目">{(data.investment_promotion === 1) ? '是' : ((data.investment_promotion === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="地区经济产业项目">{(data.economic_industry === 1) ? '是' : ((data.economic_industry === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="大型企业重大项目">{(data.large_enterprises === 1) ? '是' : ((data.large_enterprises === 2) ? '否' : '未选择')}</Descriptions.Item>
                            <Descriptions.Item label="中小企业跃升项目">{(data.medium_sized === 1) ? '是' : ((data.medium_sized === 2) ? '否' : '未选择')}</Descriptions.Item>
                        </Descriptions>
                    </Panel>}
                {(data.project_contacts_type === 0) &&
                    <Panel header="成果推荐意见" key="0">
                        感谢您的关注，请您查看相关的成果信息。
                    </Panel>}
                <Panel header="预览项目信息详情" key="3">
                    <div style={{ textAlign: "center" }}>
                        <h2>第一届新动能科技成果</h2>
                        <h2>《发布会科技成果详情》</h2>
                    </div>
                    <Divider>申报单位信息</Divider>
                    <Descriptions bordered>
                        <Descriptions.Item label="申报单位名称:" span={3}>{items.org_name}</Descriptions.Item>
                        <Descriptions.Item label="单位所在省/市:" span={2}>{items.org_province_name}</Descriptions.Item>
                        <Descriptions.Item label="单位成立时间:">{(items.establish_date !== 'null') ? items.establish_date : ''}</Descriptions.Item>
                        <Descriptions.Item label="单位产业属性:" span={2}>{Industrial(items.industrial)}</Descriptions.Item>
                        <Descriptions.Item label="单位业务属性:" >{Business(items.business)}</Descriptions.Item>
                        <Descriptions.Item label="单位从业人数（人）:" span={2}>{items.org_person}</Descriptions.Item>
                        <Descriptions.Item label="单位负责人姓名:" >{items.org_leader}</Descriptions.Item>
                        <Descriptions.Item label="成果申报人:" span={2}>{submit_name}</Descriptions.Item>
                        <Descriptions.Item label="申报人联系方式:" >{submit_account}</Descriptions.Item>
                    </Descriptions>
                    <Divider>申报成果信息</Divider>
                    <Descriptions layout="vertical" bordered >
                        <Descriptions.Item label="申报成果名称:" span={3}>{items.name}</Descriptions.Item>
                        <Descriptions.Item label="成果所属领域:" span={3}>{ProjectScopeName(items.scope)}</Descriptions.Item>
                        <Descriptions.Item label="成果简介:" span={3}><div dangerouslySetInnerHTML={{ __html: items.profile }}></div></Descriptions.Item>
                    </Descriptions>
                    <Divider>技术创新亮点</Divider>
                    <Descriptions layout="vertical" bordered>
                        <Descriptions.Item label="技术创新高度">{Height(items.height)}</Descriptions.Item>
                        <Descriptions.Item label="技术创新属性">{Attribute(items.attribute)}</Descriptions.Item>
                        <Descriptions.Item label="技术创新成果">{Achievement(items.achievement)}</Descriptions.Item>
                    </Descriptions>
                    <Divider>市场价值要点</Divider>
                    <Descriptions layout="vertical" bordered>
                        <Descriptions.Item label="核心产品市场形态">{Shape(items.shape)}</Descriptions.Item>
                        <Descriptions.Item label="项目已实现市场规模">{Scale(items.scale)}</Descriptions.Item>
                        <Descriptions.Item label="项目未来市场预期">{Expect(items.expect)}</Descriptions.Item>
                    </Descriptions>
                    <Divider>转化要素难点</Divider>
                    <Descriptions layout="vertical" bordered>
                        <Descriptions.Item label="转化所需资源难度">{Difficulty(items.difficulty)}</Descriptions.Item>
                        <Descriptions.Item label="转化资源到位程度">{Degree(items.degree)}</Descriptions.Item>
                        <Descriptions.Item label="转化项目投资力度">{Strength(items.strength)}</Descriptions.Item>
                    </Descriptions>
                    <Divider>转化已实现进程</Divider>
                    <Descriptions layout="vertical" bordered>
                        <Descriptions.Item label="TRL1-9">{Trl1_9(items.trl1_9)}
                        </Descriptions.Item>
                    </Descriptions>
                    <Divider>研发负责人</Divider>
                    <Descriptions bordered>
                        <Descriptions.Item label="姓名">{items.leader_name}</Descriptions.Item>
                        <Descriptions.Item label="学历">{Leader_education(items.leader_education)}</Descriptions.Item>
                        <Descriptions.Item label="职称">{Leader_title(items.leader_title)}</Descriptions.Item>
                    </Descriptions>
                    <Divider>研发团队</Divider>
                    <Descriptions layout="vertical" bordered>
                        <Descriptions.Item label="团队人数">{Team_person(items.team_person)}</Descriptions.Item>
                        <Descriptions.Item label="中级以上人员占比">{Team_intermediate(items.team_intermediate)}</Descriptions.Item>
                        <Descriptions.Item label="团队合作经验">{Team_experience(items.team_experience)}</Descriptions.Item>
                    </Descriptions>
                    <p>
                        <span className="bold dark-title">附件：</span>

                        {Array.isArray(files) ? files.map((item) => {
                            return (
                                <li>
                                    <a href={createFilePath(item.file_path, UPLOAD_SERVER_HOST)} className="blue" target="_black">
                                        <Icon type="link" /> {item.file_name}
                                    </a></li>)
                        })
                            : null}
                    </p>
                    <p style={{ textAlign: "center" }}>
                        <Button type="primary" onClick={hide}>关闭</Button>
                    </p>
                </Panel>
            </Collapse>
        </Modal>
    );
}

export default App;